import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import RequestDefinition from '../RequestDefinition';

import {partHeader} from '../../data/part/part';

export default new RouteComponent(`${apiRoutePrefix}/parts`, () => {
    return (
        <div>
            <ObjectHeader data={ partHeader }/>
            {
                partHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
